// src/pages/HomePage.jsx
import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/services/redteam/Hero';
import TrainerCertifications from '../components/services/TrainerCertifications';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import RedTeamServices from '../components/services/redteam/RedTeamServices';
import RedTeamMethodology from '../components/services/redteam/RedTeamMethodology';
import SecureOrgSection from '../components/services/redteam/SecureOrgSection';

const RedTeamPage = () => {
    return (
        <>
            <Navbar />
            <Hero />
            <RedTeamServices />
            <RedTeamMethodology />
            <SecureOrgSection />
            <TrainerCertifications />
            <Contact />
            <Footer />
        </>
    );
};

export default RedTeamPage;
